import React from 'react'
import './header.style.scss'
import {Link} from 'react-router-dom';
import {ReactComponent as Logo} from '../../assets/crown.svg' 
import {connect} from 'react-redux'
import CardIcon from '../card-icon/card-icon.component';
import CardDropdown from '../card-dropdown/card-dropdown.component';
import { selectHidden } from '../../redux/cart/cart.selectors';
import {createStructuredSelector} from 'reselect';

const Header = ({hidden}) => ( 
  <div className='header'>
    <Link to="/"><Logo className="logo"/></Link> 
    
    <div className='right-side'>
      <Link className='link' to="/shop">SHOP</Link>
      <CardIcon/> 
    </div>
    {
      hidden ? (null) : (<CardDropdown/>)
    }
    
  </div>
)

const mapStateToProps = createStructuredSelector({
  hidden: selectHidden
})

export default connect(mapStateToProps)(Header)